var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm._m(0);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "page-section page-section--last"
  }, [_c('div', {
    staticClass: "mb-60 mb-md-30"
  }, [_c('div', {
    staticClass: "mb-10"
  }, [_c('h3', {
    staticClass: "text-28 text-md-20"
  }, [_vm._v("전자혁신 제조지원 사업")])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-lg-6 order-lg-2"
  }, [_c('div', {
    staticClass: "img-wrap text-lg-right"
  }, [_c('img', {
    attrs: {
      "src": "/images/sub/about/business-img.png",
      "alt": "이미지"
    }
  })])]), _c('div', {
    staticClass: "col-12 col-lg-6 order-lg-1"
  }, [_c('div', {
    staticClass: "text-items"
  }, [_c('div', {
    staticClass: "text-item"
  }, [_c('div', {
    staticClass: "text-item__tit text-18 text-lg-16"
  }, [_c('strong', [_vm._v("사업명")])]), _c('div', {
    staticClass: "text-item__txt"
  }, [_c('p', {
    staticClass: "page-text"
  }, [_vm._v("전자혁신 제조지원 사업")])])]), _c('div', {
    staticClass: "text-item"
  }, [_c('div', {
    staticClass: "text-item__tit text-18 text-lg-16"
  }, [_c('strong', [_vm._v("사업기간")])]), _c('div', {
    staticClass: "text-item__txt"
  }, [_c('p', {
    staticClass: "page-text"
  }, [_vm._v("’21.4.1 ~ ’23.12.31 (3년)")])])]), _c('div', {
    staticClass: "text-item"
  }, [_c('div', {
    staticClass: "text-item__tit text-18 text-lg-16"
  }, [_c('strong', [_vm._v("지원내용")])]), _c('div', {
    staticClass: "text-item__txt"
  }, [_c('p', {
    staticClass: "page-text line-height-18"
  }, [_vm._v("빠른 제조, 부품지원, 상품화 등 전자제조서비스 지원")])])]), _c('div', {
    staticClass: "text-item"
  }, [_c('div', {
    staticClass: "text-item__tit text-18 text-lg-16"
  }, [_c('strong', [_vm._v("사업목표")])]), _c('div', {
    staticClass: "text-item__txt"
  }, [_c('p', {
    staticClass: "page-text line-height-18"
  }, [_vm._v("도심 내 전자혁신제조 플랫폼 구축으로 해외 이탈 전자 제조 수요를 국내로 복귀하여 전자제조 산업 르네상스 실현")])])])])])])]), _c('div', [_c('div', {
    staticClass: "mb-30 mb-md-15"
  }, [_c('div', {
    staticClass: "card card--shadow"
  }, [_c('div', {
    staticClass: "row card--shadow__row"
  }, [_c('div', {
    staticClass: "col-12 col-lg-2"
  }, [_c('span', {
    staticClass: "card--shadow__tit text-20 text-lg-18 font-weight-medium"
  }, [_c('strong', {
    staticClass: "color-primary"
  }, [_vm._v("1 ")]), _vm._v("비전")])]), _c('div', {
    staticClass: "col-12 col-lg-10"
  }, [_c('p', {
    staticClass: "card--shadow__txt page-text"
  }, [_c('span', {
    staticClass: "color-primary"
  }, [_vm._v("혁신제품 창출과 빠른지원을 통해 전자제조강국")]), _vm._v("에 기여한다.")])])])])]), _c('div', {
    staticClass: "mb-30 mb-md-15"
  }, [_c('div', {
    staticClass: "card card--shadow"
  }, [_c('div', {
    staticClass: "row card--shadow__row"
  }, [_c('div', {
    staticClass: "col-12 col-lg-2"
  }, [_c('span', {
    staticClass: "card--shadow__tit text-20 text-lg-18 font-weight-medium"
  }, [_c('strong', {
    staticClass: "color-primary"
  }, [_vm._v("2 ")]), _vm._v("목표")])]), _c('div', {
    staticClass: "col-12 col-lg-10"
  }, [_c('p', {
    staticClass: "card--shadow__txt page-text"
  }, [_c('span', {
    staticClass: "color-primary"
  }, [_vm._v("용산 [팩토리77] 구축을 통해 전자제조 집적화 확보")]), _vm._v(" 및 용산 전자 집적화를 통한 혁신제품 개발 생태계 확보 ")])])])])]), _c('div', {
    staticClass: "mb-30 mb-md-15"
  }, [_c('div', {
    staticClass: "card card--shadow"
  }, [_c('div', {
    staticClass: "row card--shadow__row"
  }, [_c('div', {
    staticClass: "col-12 col-lg-2"
  }, [_c('span', {
    staticClass: "card--shadow__tit text-20 text-lg-18 font-weight-medium"
  }, [_c('strong', {
    staticClass: "color-primary"
  }, [_vm._v("3 ")]), _vm._v("전략")])]), _c('div', {
    staticClass: "col-12 col-lg-10"
  }, [_c('div', {
    staticClass: "card--shadow__txt page-text"
  }, [_c('p', [_vm._v("1. 뉴 트랜드 제품기반의 빠른 생산 시스템 구축")]), _c('p', [_vm._v("2. 도심 내 제조 생태계를 위한 도시재생+산업재건 진행")]), _c('p', [_vm._v("3. 빠른 디버깅이 가능한 인력+장비 공간 구축")])])])])])]), _c('div', [_c('div', {
    staticClass: "card card--shadow"
  }, [_c('div', {
    staticClass: "row card--shadow__row"
  }, [_c('div', {
    staticClass: "col-12 col-lg-2"
  }, [_c('span', {
    staticClass: "card--shadow__tit text-20 text-lg-18 font-weight-medium"
  }, [_c('strong', {
    staticClass: "color-primary"
  }, [_vm._v("4 ")]), _vm._v("구성")])]), _c('div', {
    staticClass: "col-12 col-lg-10"
  }, [_c('div', {
    staticClass: "card--shadow__txt page-text"
  }, [_c('p', [_vm._v("1. 빠른 제조를 통한 초도양산 지원")]), _c('p', [_vm._v("2. 엔지니어 상주를 통한 직접 기술 지원 (언제니어+전문지원단)")]), _c('p', [_vm._v("3. 개발자를 위한 제조 지원 인프라 지원")])])])])])])])]);
}]

export { render, staticRenderFns }